"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
/**
 * Return true if value is in arabic else
 * returns false
 *
 * @param value
 * @returns
 */
const isArabicNumber = (value) => {
    return constants_1.DIGIT_AR_REGEX.test(value);
};
exports.default = isArabicNumber;
